/*@flow*/
import styled from '@emotion/styled';

export default (styled.span(`
  margin-left: 5px;
  font-size: 1rem;
  position: relative;
  top: 1px;
  color: #ccc;
  cursor: pointer;
  &: hover { color: #aaa; }
`): any);
